// extracted by mini-css-extract-plugin
export default {"ColStyle":"InterfaceAuth_ColStyle__AOXDn"};